import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Controller, useFormState } from 'react-hook-form';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import sharedStyles from '../../../styles/globals/index.module.scss';
import { Width } from '../../Width/index.js';
import { Label } from '../../Label/index.js';
import { getNestedValue } from '../../../utils/getNestedValue/index.js';
import { Description } from '../../Description/index.js';
import { Error } from '../../Error/index.js';
import './styles.scss';
import { constructClassName } from '../../../utils/constructClassName/index.js';
export const SelectInput = ({ control, defaultValue, description, label, name, required, rules, width, placeholder, onChange: onChangeFromProp, isCreatable, options, hideLabel, classNames, ...rest }) => {
    const { errors } = useFormState({
        control,
        name: ['errors'],
    });
    const errorMessage = getNestedValue(errors, name)?.message;
    return ((_jsx(Width, { width: width, children: _jsxs("div", { className: constructClassName([
                sharedStyles.container,
                classNames?.container,
            ]), children: [_jsx(Controller, { name: name, control: control, defaultValue: defaultValue || null, rules: {
                        required: required && {
                            message: `${label} is required`,
                            value: Boolean(required),
                        },
                        ...rules,
                    }, render: ({ field: { onChange, onBlur, value, ref, disabled }, fieldState: { isDirty } }) => (_jsxs(React.Fragment, { children: [_jsx(Label, { htmlFor: name, label: label, required: required, className: classNames?.label, hideLabel: hideLabel }), !isCreatable ? (_jsx(ReactSelect, { "aria-label": name, ref: ref, id: name, name: name, isDisabled: disabled, onBlur: onBlur, value: options?.filter((option) => (Array.isArray(value)
                                    ? value.includes(option?.value)
                                    : option?.value === value)) || (value ? [{ label: value, value }] : null), options: options, onChange: (e) => {
                                    const selectedValue = Array.isArray(e) ? e.map((option) => option.value) : e.value;
                                    onChange(selectedValue);
                                    onChangeFromProp?.(selectedValue);
                                }, placeholder: isDirty ? undefined : placeholder, classNamePrefix: "invx_select", className: classNames?.input, ...rest })) : (_jsx(CreatableSelect, { "aria-label": name, ref: ref, id: name, name: name, isDisabled: disabled, onBlur: onBlur, 
                                // eslint-disable-next-line no-nested-ternary
                                value: ((value && Array.isArray(value))
                                    ? value?.map((val) => ({ label: val, value: val }))
                                    : value
                                        ? [{ label: value, value }]
                                        : null), onChange: (e) => {
                                    const selectedValue = Array.isArray(e) ? e.map((option) => option.value) : e.value;
                                    onChange(selectedValue);
                                    onChangeFromProp?.(selectedValue);
                                }, placeholder: isDirty ? undefined : placeholder, classNamePrefix: "invx_select", className: classNames?.input, ...rest }))] })) }), description && (_jsx(Description, { description: description, className: classNames?.description })), errorMessage && (_jsx(Error, { message: errorMessage, className: classNames?.error }))] }) })));
};
